import { createSelector, setGlobalDevModeChecks } from 'reselect'

setGlobalDevModeChecks({ identityFunctionCheck: 'never' })

export const authPending = (state) => {
  return state.session.authPending
}

export const appLoading = (state) => {
  return state.session.appLoading
}

export const userId = (state) => {
  return state.session.userId
}

export const authenticated = createSelector(
  userId, authPending,
  (userId, authPending) => !!userId && !authPending
)

export const features = (state) => {
  return state.session.features
}

export const partners = (state) => {
  return state.session.partners
}

export const mainPartner = createSelector(
  partners,
  (partners) => {
    const mainPartner = partners.find(partner => partner.mainPartner === true)
    return mainPartner
  }
)
